import { TextInput } from 'cpool-components/input/TextInput';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormRow } from '~/components/FormRow/FormRow';
import { SectionCard } from '~/components/SectionCard/SectionCard';

export const SmtpAccess: React.FC<{ disabled?: boolean; outlined?: boolean }> = ({ disabled, outlined }) => {
    const { t } = useTranslation();
    const { register } = useFormContext();

    return (
        <SectionCard title={t('users.create.MODAL.SMTP.TITLE')} outlined={outlined}>
            <div className="flex flex-col gap-2">
                <FormRow label={t('users.create.MODAL.SMTP.SMTP_USERNAME')} htmlFor="smtp.user">
                    <TextInput id="smtp.user" className="grow" disabled={disabled} {...register('smtp.user')} />
                </FormRow>
                <FormRow label={t('users.create.MODAL.SMTP.SMTP_PASSWORD')} htmlFor="smtp.password">
                    <TextInput
                        id="smtp.password"
                        className="grow"
                        type="password"
                        disabled={disabled}
                        {...register('smtp.password')}
                    />
                </FormRow>
            </div>
        </SectionCard>
    );
};
